<template>
  <section class="home_banner">
    <div class="home_banner__inner">
      <!-- 上半部分：轮播图 + 公告信息 -->
      <div class="top_section">
        <!-- 左侧轮播图 -->
        <div class="carousel_wrapper">
          <div class="carousel_container" ref="carouselRef">
            <div
              class="carousel_track"
              :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
            >
              <div
                v-for="(item, index) in bannerList"
                :key="index"
                class="carousel_item"
                :style="{
                  cursor: item.bannerType == 2 ? 'pointer' : 'default',
                }"
                @click="handleBannerClick(item)"
              >
                <img :src="item.imgUrl" alt="" />
              </div>
            </div>
            <!-- 左右切换按钮 -->
            <div class="carousel_arrow carousel_arrow_left" @click="prevSlide">
              <img src="@/assets/img/swiperleft.png" alt="" />
            </div>
            <div class="carousel_arrow carousel_arrow_right" @click="nextSlide">
              <img src="@/assets/img/swiperRight.png" alt="" />
            </div>
            <!-- 底部指示点 -->
            <div class="carousel_dots">
              <span
                v-for="(item, index) in bannerList"
                :key="index"
                :class="['dot', { active: currentIndex === index }]"
                @click="goToSlide(index)"
              ></span>
            </div>
          </div>
        </div>

        <!-- 右侧公告信息 -->
        <div class="announcement_wrapper">
          <div class="announcement_header">
            <div class="announcement_header_title">
              <div class="announcement_header_icon"></div>
              <span>公告信息</span>
            </div>
            <div @click="toNewsList" class="more_text">查看更多&gt;</div>
          </div>
          <div class="announcement_list">
            <div
              v-for="(item, index) in announcementList"
              :key="index"
              class="announcement_item"
              @click="linkJump('/info/detail', { type: 'notice', id: item.id })"
            >
              <img
                class="dot_icon"
                src="@/assets/img/announcementIco.png"
                alt=""
              />
              <span class="text">{{ item.noticeTitle }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 中间统计数据 -->
      <div class="stats_section">
        <div class="stats_item">
          <img src="@/assets/img/Historicaltransactions.png" alt="" />
          <div class="stats_info">
            <div class="stats_number">
              {{ statsData.orderNum }}<span class="unit">单</span>
            </div>
            <div class="stats_label">历史成交单量</div>
          </div>
        </div>
        <div class="stats_item">
          <img src="@/assets/img/Cumulativefinancing.png" alt="" />
          <div class="stats_info">
            <div class="stats_number">
              {{ statsData.financeAmount }}<span class="unit">万元</span>
            </div>
            <div class="stats_label">累积融资额</div>
          </div>
        </div>
        <div class="stats_item">
          <img src="@/assets/img/businesscustomer.png" alt="" />
          <div class="stats_info">
            <div class="stats_number">
              {{ statsData.industryCustomer }}<span class="unit">+</span>
            </div>
            <div class="stats_label">产业客户</div>
          </div>
        </div>
        <div class="stats_item">
          <img src="@/assets/img/Cooperativesupplier.png" alt="" />
          <div class="stats_info">
            <div class="stats_number">
              {{ statsData.supplier }}<span class="unit">+</span>
            </div>
            <div class="stats_label">合作供应商</div>
          </div>
        </div>
        <div class="stats_item">
          <img src="@/assets/img/Cumulativecoverage.png" alt="" />
          <div class="stats_info">
            <div class="stats_number">
              {{ statsData.category }}<span class="unit">+</span>
            </div>
            <div class="stats_label">累积覆盖品类</div>
          </div>
        </div>
      </div>

      <!-- 底部功能卡片 -->
      <div class="feature_section">
        <div
          class="feature_item"
          :style="{
            backgroundImage: `url(${bringtogetherBg})`,
            backgroundSize: '100% 100%',
          }"
        >
          <div class="feature_content">
            <div class="feature_title">智能撮合，高效寻源</div>
            <div class="feature_desc">
              采发发布需求，优质供应商在线响应，<br />提升采购效率，降低寻源成本。
            </div>
          </div>
        </div>
        <div
          class="feature_item"
          :style="{
            backgroundImage: `url(${contractBg})`,
            backgroundSize: '100% 100%',
          }"
        >
          <div class="feature_content">
            <div class="feature_title">合同驱动，履约覆盖</div>
            <div class="feature_desc">
              平台全节点支持数据采录及补全，<br />全方位保管数据集合点
            </div>
          </div>
        </div>
        <div
          class="feature_item"
          :style="{
            backgroundImage: `url(${tradeBg})`,
            backgroundSize: '100% 100%',
          }"
        >
          <div class="feature_content">
            <div class="feature_title">凭真贸易，便捷融资</div>
            <div class="feature_desc">
              整合合同、物流、发票等真实贸易流，<br />生成银行认可的融资申请材料。
            </div>
          </div>
        </div>
        <div
          class="feature_item"
          :style="{
            backgroundImage: `url(${evidenceBg})`,
            backgroundSize: '100% 100%',
          }"
        >
          <div class="feature_content">
            <div class="feature_title">全链存证，司法可信</div>
            <div class="feature_desc">
              关键单据与操作全链上留痕存证，<br />数据不可篡改，提供有效法律证据。
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { bannerApi, noticetApi, statsDataApi } from "@/api/banner";
export default {
  name: "HomeBanner",
  data() {
    return {
      currentIndex: 0,
      bannerList: [],
      announcementList: [],
      statsData: {},
      autoPlayTimer: null,
      // 功能卡片背景图
      bringtogetherBg: require("@/assets/img/bringtogether.png"),
      contractBg: require("@/assets/img/contract.png"),
      tradeBg: require("@/assets/img/trade.png"),
      evidenceBg: require("@/assets/img/Evidence.png"),
    };
  },
  mounted() {
    this.getBannerList();
    this.getAnnouncementList();
    this.getStatsData();
    this.startAutoPlay();
  },
  beforeDestroy() {
    this.stopAutoPlay();
  },
  methods: {
    // 接口1：获取轮播图数据
    async getBannerList() {
      const res = await bannerApi();
      if (res.code == 1) {
        this.bannerList = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    handleBannerClick(item) {
      if (item.bannerType == 2) {
        const url = this.$router.resolve({
          path: "/bannerDetail",
          query: {
            id: item.id,
          },
        });
        window.open(url.href, "_blank");
      }
    },
    // 接口2：获取公告信息
    async getAnnouncementList() {
      const res = await noticetApi({ size: 9 });
      if (res.code == 1) {
        this.announcementList = res.data;
      } else {
        this.$message.error(res.message);
      }
    },

    // 接口3：获取展示数据
    async getStatsData() {
      const res = await statsDataApi();
      if (res.code == 1) {
        this.statsData = res.data;
      } else {
        this.$message.error(res.message);
      }
    },

    prevSlide() {
      this.currentIndex =
        this.currentIndex === 0
          ? this.bannerList.length - 1
          : this.currentIndex - 1;
    },

    nextSlide() {
      this.currentIndex =
        this.currentIndex === this.bannerList.length - 1
          ? 0
          : this.currentIndex + 1;
    },

    goToSlide(index) {
      this.currentIndex = index;
    },

    startAutoPlay() {
      this.autoPlayTimer = setInterval(() => {
        this.nextSlide();
      }, 5000);
    },

    stopAutoPlay() {
      clearInterval(this.autoPlayTimer);
    },
    toNewsList() {
      this.$router.push({
        path: "/info",
        query: { type: "notice" },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/static/styles/variables.less";
.home_banner {
  width: 100%;
  &__inner {
    width: @defaultWidth;
    margin: 0 auto;
    padding: 20px 0;
  }
}

// 上半部分
.top_section {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

// 轮播图
.carousel_wrapper {
  flex: 1;
}

.carousel_container {
  position: relative;
  width: 100%;
  height: 452px;
  border-radius: 12px;
  overflow: hidden;
}

.carousel_track {
  display: flex;
  transition: transform 0.5s ease;
  height: 100%;
}

.carousel_item {
  min-width: 100%;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.carousel_arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;

  img {
    width: 59px;
    height: 59px;
  }

  &_left {
    left: 24px;
  }

  &_right {
    right: 24px;
  }
}

.carousel_dots {
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
  z-index: 10;

  .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.5);
    cursor: pointer;

    &.active {
      background: #fff;
    }
  }
}

// 公告信息
.announcement_wrapper {
  width: 449px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 12px;
  padding: 30px;
}

.announcement_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  .announcement_header_title {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .announcement_header_icon {
    width: 4px;
    height: 16px;
    background: #3b75dd;
  }
}

.announcement_list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 25px;
}

.announcement_item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #333333;
  line-height: 24px;
  cursor: pointer;

  .dot_icon {
    width: 6px;
    height: 8px;
    flex-shrink: 0;
  }

  .text {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    font-size: 14px;
    &:hover {
      color: #3b75dd;
    }
  }

  &:hover {
    color: #3b75dd;
  }
}

// 统计数据
.stats_section {
  display: flex;
  justify-content: space-between;
  background: #fff;
  border-radius: 12px;
  padding: 35px 53px;
  margin-bottom: 30px;
}

.stats_item {
  display: flex;
  align-items: center;
  gap: 12px;

  img {
    width: 80px;
    height: 80px;
  }
}

.stats_info {
  display: flex;
  flex-direction: column;
}

.stats_number {
  font-size: 32px;
  font-weight: 600;
  color: #3b75dd;
  line-height: 45px;

  .unit {
    font-size: 18px;
    font-weight: 400;
    margin-left: 2px;
  }
}

.stats_label {
  font-size: 14px;
  color: #999;
}

// 功能卡片
.feature_section {
  display: flex;
  gap: 20px;
}

.feature_item {
  width: 345px;
  height: 164px;
  box-sizing: border-box;
  flex: 1;
  background: #fff;
  border-radius: 12px;
  padding: 44px 0 44px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:hover {
    .feature_title {
      color: #3b75dd;
    }
    .feature_desc {
      color: #c2d4f4;
    }
  }
}

.feature_content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.feature_title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.feature_desc {
  font-size: 12px;
  color: #999;
  line-height: 1.5;
}
</style>
